import { render } from "./PrivateHome.vue?vue&type=template&id=3cd04847&scoped=true"
import script from "./PrivateHome.vue?vue&type=script&lang=js"
export * from "./PrivateHome.vue?vue&type=script&lang=js"

import "./PrivateHome.vue?vue&type=style&index=0&id=3cd04847&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd04847"]])

export default __exports__